// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.paramsStyle[data-v-0681ebcf] {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.mb-0[data-v-0681ebcf] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
